module.exports = __webpack_public_path__ + "static/bg01-336e4976745a52d930f4da8ef8fcaa0e.jpg";